module.exports = __webpack_public_path__ + "static/Radium_sketches-c3e39e8996d7edf745ab1bbafe8508b6.png";